/* email.service.ts */
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class EmailService {
  private apiUrl = environment.apiUrlNewCall;

  constructor(private http: HttpClient) {}

  sendParentMembership(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}auth/parent-membership`, data);
  }

  sendChildRegistration(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}auth/child-registration`, data);
  }

  sendProgramRegistration(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}auth/program-registration`, data);
  }

  sendContactUs(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}auth/contact-us`, data);
  }
}
